import React, {useContext} from 'react';
import {FormContext} from './MDForm';
import {propsToCSS} from '../css';
import {BASIC_ELEMENT_SCHEMA, Group} from '../layout/Group';
import {merge} from 'lodash';
import {TooltipHint} from './TooltipHint';

const NO_TRACK = v => v;

export function CCPANotice(props) {
  const formContext = useContext(FormContext);
  const { getValueByAttr } = formContext;

  const style = {
    fontStyle: 'inherit',
    fontWeight: 'bold',
    fontSize: 'inherit',
    marginBottom: '0'
  }

  const styleRed = {
    fontStyle: 'inherit',
    fontWeight: 'bold',
    fontSize: 'inherit',
    color: 'red',
    marginBottom: '0'
  }

  return <h1 tableindex={1} {...propsToCSS(props)} {...props.elementAttr} style={style}>
  California Residents: Please see our <a target="_blank" rel="noopener noreferrer" href="https://www.berkley.com/privacy#californiaConsumerPrivacyPolicy">CCPA Notice at Collection</a> of Personal Information
  </h1>;
}

CCPANotice.schema = merge({
  properties: {
    value: {
      type: 'string',
    },
    requireAll: {
      type: 'boolean',
    },
  }
}, BASIC_ELEMENT_SCHEMA);